import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAccessibleItems } from '../config/navigation';

// Get the modifier key based on platform
export const getModifierKey = () => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  return isMac ? '⌘' : 'Ctrl';
};

export const getModifierKeyName = () => {
  const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
  return isMac ? 'Cmd' : 'Ctrl';
};

// Single-key navigation shortcuts (modifier + letter). The key-to-route map is
// derived from the nav config (items with a `shortcut`) so there is one source
// of truth. Note: 'k' is reserved for the command palette (see CommandPalette).
const useKeyboardShortcuts = (isAuthed) => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!isAuthed) return undefined;

    const handleKeyPress = (event) => {
      // Check if Cmd (Mac) or Ctrl (Windows/Linux) is pressed
      const isModifierPressed = event.metaKey || event.ctrlKey;

      if (!isModifierPressed) return;

      // Find matching shortcut among the pages this user can reach
      const item = getAccessibleItems().find(
        (i) => i.shortcut && i.shortcut.toLowerCase() === event.key.toLowerCase(),
      );

      if (item) {
        event.preventDefault();
        navigate(item.path);
      }
    };

    window.addEventListener('keydown', handleKeyPress);

    return () => {
      window.removeEventListener('keydown', handleKeyPress);
    };
  }, [isAuthed, navigate]);
};

export default useKeyboardShortcuts;
